import styled from 'styled-components';
import Parent from '../Base/style';
const SearchWrapper = styled(Parent)`
height: 40px;
.MuiInputBase-input{
    background-color: #fff;
}
`;
export default SearchWrapper;
